import { useState, useCallback } from 'react';
import { ILineItem } from '../types/line-item.types';
import { processLineItems } from '../services/lineItem.service';

export const useReviewState = () => {
    const [reviewRequiredLineItems, setReviewRequiredLineItems] = useState<Set<number>>(new Set());
    const [reviewRequiredState, setReviewRequiredState] = useState<Map<number, boolean>>(new Map());
    const [lineItemState, setLineItemState] = useState<Map<number, Partial<ILineItem>>>(new Map());

    const processItems = useCallback((items: ILineItem[]) => {
        const processed = processLineItems(items);
        
        setReviewRequiredLineItems(prev => new Set([...prev, ...processed.reviewRequiredIds]));
        setReviewRequiredState(prev => {
            const newState = new Map(prev);
            processed.reviewRequiredStateMap.forEach((value, key) => {
                newState.set(key, value);
            });
            return newState;
        });
        setLineItemState(prev => {
            const newState = new Map(prev);
            processed.lineItemStateMap.forEach((value, key) => {
                newState.set(key, value);
            });
            return newState;
        });
    }, []);

    const updateReviewRequired = useCallback((lineItemIds: number[], reviewRequired: boolean) => {
        setReviewRequiredState(prev => {
            const newState = new Map(prev);
            lineItemIds.forEach(id => {
                newState.set(id, reviewRequired);
            });
            return newState;
        });
    }, []);

    const updateLineItem = useCallback((lineItemId: number, updates: Partial<ILineItem>) => {
        setLineItemState(prev => {
            const newState = new Map(prev);
            const existing = newState.get(lineItemId) || {};
            newState.set(lineItemId, { ...existing, ...updates });
            return newState;
        });
    }, []);

    return {
        reviewRequiredLineItems,
        reviewRequiredState,
        lineItemState,
        processItems,
        updateReviewRequired,
        updateLineItem,
        setReviewRequiredState,
        setLineItemState
    };
};

